import "./Header.css";

export default function Header() {
  return (
    <section className="header">
      <header>
        <h1  className="header-title"> Hello.</h1>
        <div className="header-title-box">
          ⚛ React developer based in Ecuador!
        </div>
      </header>
    </section>
  );
}
